module.exports = __webpack_public_path__ + "img/car_00042.b334b56b.jpg";